import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import {
  RenderInput,
  RenderSelect,
} from "../../Common/InputComponents/Inputs.jsx";
import _ from "underscore";
import {
  requiredTarget,
  requiredSeq,
  maxLength17,
  minLength5,
  hasValidWhitespace,
  validateMutationSequence,
} from "../../../util/validations.js";
import { firstSeventeen, removeSpaces } from "../../../util/format.js";
import {
  tooltipFluorophores,
  tooltipSequence,
  tubeFormatSelector,
} from "../../Common/Misc/Tooltips.jsx";

const genomeOptions = [
  "Homo sapiens",
  "Mus musculus",
  "Rattus norvegicus",
  "Other",
];

const fluorophoreOptions = [
  { name: "FAM/HEX", value: "FAM/HEX" },
  { name: "Cy5/Cy5.5", value: "Cy5/Cy5_5" },
];
const tubeFormatOptions = [
  { text: "Single Tube", value: "SingleTube" },
  { text: "Two Tube", value: "TwoTube" },
];

export const MutationDetectionSequence = ({ input, index, custom }) => {
  const validationErrorDetails =
    (custom &&
      custom.validatedAssayDetails &&
      custom.validatedAssayDetails[index]) ||
    {};
  const mutationDetectionSequence = input && input.name;
  const formObj = custom && custom.formObj;
  const targetByValue =
    formObj &&
    formObj.values &&
    formObj.values.mutationDetectionForm &&
    formObj.values.mutationDetectionForm[index] &&
    formObj.values.mutationDetectionForm[index].targetby;

  const genomeValue =
    formObj &&
    formObj.values &&
    formObj.values.mutationDetectionForm &&
    formObj.values.mutationDetectionForm[index] &&
    formObj.values.mutationDetectionForm[index].mutationdetectionsequence &&
    formObj.values.mutationDetectionForm[index].mutationdetectionsequence
      .genome;

  const clearValidationMessages = () => {
    custom.actions.clearValidationMessages(index);
  };

  return (
    <div>
      <div className="inputs">
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <Field
                name={`${mutationDetectionSequence}.assayTargetName`}
                placeholder="17 chars. maximum"
                className="form-control"
                type="text"
                component={RenderInput}
                label="Assay Target Name:"
                validate={[requiredTarget, hasValidWhitespace, minLength5]}
                normalize={firstSeventeen}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <Field
                name={`${mutationDetectionSequence}.sequence`}
                className="form-control"
                type="textArea"
                rows="8"
                placeholder="e.g., GGTCAGATACAGGCAAGCGGTCAGATACAGGCAAGCACAAGGCAAGCACA[G/A]CTCGGTAAGTGGAGATTCGAGCGGTCAGATACAGGCAAGCACAAGGCAAGCAC (minimum length = 61 base pairs on each side of the mutation)"
                component={RenderInput}
                label="Sequence:"
                validate={[requiredSeq, validateMutationSequence]}
                tooltip={tooltipSequence("MutationDetection")}
                normalize={removeSpaces}
                serverValidation={validationErrorDetails}
                onChange={clearValidationMessages}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <Field
                name={`${mutationDetectionSequence}.genome`}
                className="form-control"
                component={RenderSelect}
                label="Genome:"
              >
                {genomeOptions &&
                  genomeOptions.map((option) => {
                    return (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    );
                  })}
              </Field>
            </div>
            <div className="form-group">
              <Field
                name={`${mutationDetectionSequence}.fluorophores`}
                className="form-control"
                component={RenderSelect}
                label="Fluorophore(s):"
                tooltip={tooltipFluorophores}
              >
                {fluorophoreOptions &&
                  fluorophoreOptions.map((option) => {
                    return (
                      <option key={option.name} value={option.value}>
                        {option.name}
                      </option>
                    );
                  })}
              </Field>
            </div>
            <div className="form-group">
              <Field
                name={`${mutationDetectionSequence}.assayFormat`}
                className="form-control"
                component={RenderSelect}
                label="Tube Format:"
                tooltip={tubeFormatSelector}
              >
                {tubeFormatOptions &&
                  tubeFormatOptions.map((option) => {
                    return (
                      <option key={option.value} value={option.value}>
                        {option.text}
                      </option>
                    );
                  })}
              </Field>
            </div>
          </div>
        </div>
        <br />
        {/*Warning Text message for others*/}

        {targetByValue === "sequence" && genomeValue === "Other" && (
          <div className="row container d-flex flex-column align-items-start">
            <div className=" warning-header">
              <strong>*Important Note for Selected Genome — Other:</strong>
            </div>

            <div className="warning-descrioption">
              <p>
                The design engine performs a specificity check against the
                reference genome assembly selected. If <b>Other</b> is selected,
                the design engine will not perform a specificity check against a
                reference genome, but all of the other strict assay design
                parameters will be followed. Select your input sequence
                carefully and be as specific as possible.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

MutationDetectionSequence.propTypes = {
  //fields: PropTypes.object.isRequired,
};
